import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Layout, Form, Button, Input, notification } from 'antd'
import { graphql } from 'react-apollo'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import createUserMutation from '../graphql/mutations/createUser'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

class AddUser extends Component {
  state = {
    submitting: false,
  }
  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ submitting: true })
    const username = this.props.form.getFieldValue('username')
    const name = this.props.form.getFieldValue('name')
    const record = {
      username,
      name,
      role: 'employee',
    }
    try {
      await this.props.createUser({ variables: { record } })
      this.props.history.push('/users')
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
      this.setState({ submitting: false })
    }
  }
  handleInputChange = (e) => {
    this.props.form.setFieldsValue({ [e.target.name]: e.target.value })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    return (
      <Layout>
        <Navbar selected="user:2" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form onSubmit={this.handleSubmit}>
              <FormItem
                {...formItemLayout}
                label="Username"
              >
                {getFieldDecorator('username', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input username!' }],
                })(
                  <Input type="text" name="username" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Name"
              >
                {getFieldDecorator('name', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input name!' }],
                })(
                  <Input type="text" name="name" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit" disabled={this.state.submitting}>Add user</Button>
              </FormItem>
            </Form>
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
AddUser.propTypes = {
  form: PropTypes.shape(),
}
AddUser.defaultProps = {
  form: {},
}

export default graphql(createUserMutation, { name: 'createUser' })(Form.create()(AddUser))



// WEBPACK FOOTER //
// ./src/pages/AddUser.js